import EstatePlanning from './estatePlanning';

export default EstatePlanning;
